import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialogProps } from '../../../../lib/components';
import { BenefitEnum } from '@pxtra-client-lib-legacy/gen';
import { CompanyJobbikeSettings } from '../../../benefits/portfolio/jobbike';
import { CompanyBKVSettings } from '../../../benefits/portfolio/bkv';
import { CompanyBAVSettings } from '../../../benefits/portfolio/bav';
import { CompanyHardwareSettings } from '../../../benefits/portfolio/mpp';
import { useSnackbar } from 'notistack';
import { useStore } from '../../../../hooks/useStore';
import { ContractViewDialog } from '../../../../lib/components/compound/dialogs/contractViewDialog';

type Props = Omit<ConfirmationDialogProps, 'variant' | 'title' | 'contentText'> & {
  benefit: BenefitEnum;
  settingsData?: Record<string, boolean | string | undefined>;
  contractData?:
    | Record<string, string | number | boolean | null | undefined>
    | Array<Record<string, string | number | boolean | null | undefined>>;
};

export const ContractInformation: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();

  const [pendingChanges, setPendingChanges] = useState<Record<string, string> | null>(null);
  const snackbar = useSnackbar();

  const handleClose = async () => {
    if (pendingChanges && props.benefit == 'jobbike') {
      try {
        await companyStore.updateJobbikeSettings(pendingChanges);
        await companyStore.fetchBenefitSettings();
        snackbar.enqueueSnackbar(t('template:CHANGES_SAVED'), { variant: 'success' });
      } catch (error) {
        console.error(error);
        snackbar.enqueueSnackbar(t('template:SAVING_ERROR'), { variant: 'error' });
      }
    }
    props.onClose?.();

    setPendingChanges(null);
  };

  const getDialogContent = () => {
    switch (props.benefit) {
      case 'jobbike':
        return <CompanyJobbikeSettings onPendingChanges={setPendingChanges} />;
      case 'bav':
        return <CompanyBAVSettings dialogView />;
      case 'bkv':
        return <CompanyBKVSettings dialogView />;
      case 'mpp':
        return <CompanyHardwareSettings dialogView />;
      default:
        return '';
    }
  };

  return <ContractViewDialog {...props} onClose={handleClose} content={getDialogContent()} />;
};
